/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { underwritingSave } from "../../funcs/underwritingSave.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.SaveUnderwritingRequest$inboundSchema,
};

export const tool$underwritingSave: ToolDefinition<typeof args> = {
  name: "underwriting-save",
  description: `Create or update the account's underwriting.

Read our [underwriting guide](https://docs.moov.io/guides/accounts/requirements/underwriting/) to learn more.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/profile.write\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await underwritingSave(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
